export var MarksSide = /*#__PURE__*/function (MarksSide) {
  MarksSide[MarksSide["None"] = 0] = "None";
  MarksSide[MarksSide["Left"] = -1] = "Left";
  MarksSide[MarksSide["Right"] = 1] = "Right";
  return MarksSide;
}({});